import AnalyticsTypes from '../constants/AnalyticsTypes';

function getAnalytics(type: AnalyticsTypes): string | null {
  return sessionStorage.getItem(`analytics:${type}`);
}

export default getAnalytics;
